import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import "./i18n";
import App from "./App";

Sentry.init({
  dsn: "https://15733922ebf8ef036c411865d3421b5f@o4511167488262144.ingest.us.sentry.io/4511167498813440",
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
